export default "https://cdn-static.gokick.com/assets/34a72110398b299a93da730cfac0263ae4687154/images/tangerine-flavor.074c3354820283b11da157ce9290935a.png";